function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 4h6L7.71 6.29l5.29 5.3V20h-2v-7.59l-4.71-4.7L4 10V4zm12.29 2.29L14 4h6v6l-2.29-2.29-2.88 2.88-1.42-1.42 2.88-2.88z",
  fill: "#666"
})));